import { useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { TriangleAlert } from "lucide-react";
import { adminApi } from "@/lib/auth";
import { logWarn } from "@/lib/log";

const formatDateEs = (iso) => {
  const [y, m, d] = (iso || "").slice(0, 10).split("-");
  return d ? `${d}/${m}/${y}` : "";
};

/** Al entrar en el Espacio Gestor avisa de los instructores que se van a
 *  quedar sin mascarillas en los próximos días. */
export const MaskRunoutAlert = ({ onGoToMasks }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    adminApi
      .get("/admin/masks/alerts")
      .then((res) => setData(res.data?.alerts?.length ? res.data : null))
      .catch((e) => logWarn("No se pudo comprobar el stock de mascarillas", e));
  }, []);

  return (
    <AlertDialog open={!!data} onOpenChange={(o) => !o && setData(null)}>
      <AlertDialogContent data-testid="mask-runout-alert">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-red-700">
            <TriangleAlert className="h-5 w-5" /> Mascarillas: envía más
          </AlertDialogTitle>
          <AlertDialogDescription>
            Estos instructores se quedarán sin mascarillas en los próximos{" "}
            {data?.days} días. Envíales más para que les lleguen a tiempo.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="space-y-2 text-sm">
          {(data?.alerts || []).map((a) => (
            <li
              key={a.instructor_id}
              className="rounded-md border border-red-200 bg-red-50 p-3"
              data-testid={`mask-runout-${a.instructor_id}`}
            >
              <div className="font-semibold text-zinc-950">{a.instructor_name}</div>
              <div className="text-zinc-700">
                Le quedan {a.on_hand}
                {a.pending_total > 0 ? ` (+${a.pending_total} en camino)` : ""}. El{" "}
                {formatDateEs(a.runout_date)}
                {a.runout_client ? ` (${a.runout_client})` : ""} le faltarán{" "}
                <strong>{a.runout_missing}</strong>.
              </div>
            </li>
          ))}
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="mask-runout-close">Entendido</AlertDialogCancel>
          <AlertDialogAction
            onClick={onGoToMasks}
            className="bg-red-700 hover:bg-red-800 text-white"
            data-testid="mask-runout-go"
          >
            Ir a Mascarillas
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
